import { DataGrid, type DataGridProps } from '@shared/components';

import { columns, type QSetGeneratorResultColumn } from './columns';

export type PassedResultsTableProps = Omit<DataGridProps<QSetGeneratorResultColumn>, 'columns'>;

export default function PassedResultsTable(props: Readonly<PassedResultsTableProps>) {
  return (
    <DataGrid<QSetGeneratorResultColumn>
      columns={columns}
      {...props}
      checkboxSelection
      keepNonExistentRowsSelected
      disableColumnMenu
      rowHeight={48}
      columnHeaderHeight={48}
      sx={(theme) => ({
        bgcolor: theme.palette.common.white,
        '--unstable_DataGrid-radius': theme.shape.rounded(0),
        borderRadius: theme.shape.rounded(0),
        '.MuiDataGrid-columnHeaders': {
          bgcolor: theme.palette.grey[100],
          borderTop: '1px solid',
          borderBottom: '1px solid',
          borderColor: theme.palette.grey[300],
        },
        '&& .MuiCheckbox-root': {
          color: theme.palette.grey[400],
          '> svg': {
            fontSize: '24px',
          },
          '&.Mui-checked': {
            color: theme.palette.primary.main,
          },
        },
        '&& .MuiDataGrid-cell, && .MuiDataGrid-row': {
          borderBottom: '1px solid',
          borderColor: theme.palette.grey[300],
        },
        '&& .MuiDataGrid-row': {
          '&.Mui-selected': {
            bgcolor: theme.palette.primary.lighter,
          },
        },
        '> .MuiDivider-root': {
          borderColor: theme.palette.grey[300],
          mt: '-1px',
        },
        '> .MuiBox-root': {
          p: theme.spacing(3, 4),
          bgcolor: theme.palette.common.white,
          '& .MuiToolbar-root': {
            minHeight: 'unset',
            height: 'unset',
            '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
              m: 0,
            },
            '& .MuiTablePagination-actions': {
              ml: theme.spacing(1),
              '> button': {
                p: theme.spacing(1),
              },
            },
          },
        },
      })}
    />
  );
}
